export default __webpack_public_path__ + "static/licence-SA-3145a445a5e994cc65759dbd73cbc2ff.svg";